module.exports = __webpack_public_path__ + "static/media/SuccessIllustration.628f056c.jpg";